export const POST_REQUEST = 'consultationsForm/POST_REQUEST'
export const POST_SUCCESS = 'consultationsForm/POST_SUCCESS'
export const POST_FAILURE = 'consultationsForm/POST_FAILURE'
export const GET_REQUEST = 'consultationsForm/GET_REQUEST'
export const GET_SUCCESS = 'consultationsForm/GET_SUCCESS'
export const GET_FAILURE = 'consultationsForm/GET_FAILURE'
export const UPDATE_LAWYER = 'consultationsForm/UPDATE_LAWYER'